import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink px-4 pb-32 pt-12 text-center sm:pb-28" data-id="element-147" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl" data-id="element-148" data-mp="3ggaohovss12a">
        <p className="font-serif text-2xl font-black text-white" data-id="element-149" data-mp="3gh3rcermy6f5">Perio Blueprint™</p>
        <p className="mt-2 text-white/70" data-id="element-150" data-mp="32pp39tivff18">Organize your knowledge. Connect the concepts. Structure your case review.</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-151" data-mp="3uf0p3ehtsive">Created by Dr. Nathan Brooks.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/50" data-id="element-152" data-mp="3ucxndx7b91au">
          Educational resource only. This product does not replace formal training, current scientific evidence,
          specialist consultation, comprehensive clinical evaluation, or patient-specific professional judgment.
        </p>
        <p className="mt-4 text-xs text-white/40" data-id="element-153" data-mp="3qf9qwppyz0gu">© 2026 · Perio Blueprint™ · All rights reserved.</p>
      </div>
    </footer>;
}